export enum ChainSlug {
  EVM = 'EVM', // EVM chain
  BTC = 'BTC', // Bitcoin chain
  LTC = 'LTC', // Litecoin chain
  MVX = 'MVX', // MultiversX
  TRON = 'TRON', // Tron chain
  DOGE = 'DOGE', // Dogecoin chain
  POL = 'POL', // Polygon chain
  ARB = 'ARB', // Arbitrum chain
  CWEB = 'CWEB', // Coinweb chain
  SOL = 'SOL', // Solana chain
}

export enum TokenOrder {
  FIRST = 'FIRST',
  SECOND = 'SECOND',
}

export enum Direction {
  BUY = 'BUY',
  SELL = 'SELL',
}

export const enum TrackType {
  SWAP = 'SWAP',
  Deposit = 'Deposit',
  Withdraw = 'Withdraw',
  CreateBid = 'CreateBid',
  CreatePactOrder = 'CreatePactOrder',
  CancelBid = 'CancelBid',
  CancelPactOrder = 'CancelPactOrder',
  Finalize = 'Finalize',
}
